var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFlag)?_c('div',{staticClass:"cmp_pic_enlarge_mask",on:{"click":function($event){return _vm.close()}}},[_c('img',{attrs:{"src":_vm.picUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }